import styled from 'styled-components';
import { Select } from 'zui/Antd';

const MultiSelect = styled(Select)`
	&.ant-select:not(.ant-select-customize-input) .ant-select-selector {
		height: auto;
	}
`;

export default MultiSelect;
